import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Grid, Percent, User, ShoppingBag } from 'lucide-react';
import './MobileBottomNav.css';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: 'home', title: 'Asosiy', icon: Home, path: '/' },
    { id: 'catalog', title: 'Katalog', icon: ShoppingBag, path: '/products' },
    { id: 'categories', title: 'Kategoriyalar', icon: Grid, path: '/products?category=all' },
    { id: 'sale', title: 'Chegirma', icon: Percent, path: '/products?sale=true' },
    { id: 'profile', title: 'Profil', icon: User, path: '/profile' }
  ];

  return (
    <div className="mobile-bottom-nav">
      {navItems.map((item) => {
        const Icon = item.icon;
        
        // Accurate matching for active state
        let isActive = false;
        if (item.path === '/') {
          isActive = location.pathname === '/';
        } else if (item.path.includes('?')) {
          isActive = location.pathname + location.search === item.path;
        } else {
          isActive = location.pathname === item.path && !location.search;
        }

        return (
          <button 
            key={item.id}
            className={`nav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <Icon size={22} className="nav-icon" />
            <span className="nav-title">{item.title}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MobileBottomNav;
